<template>
  <SearchIndex :page-props="searchPageProps" :mart-id="id">
    <template v-if="!loading" #header="{ total }">
      <div :class="_.hd">
        <div :class="_.cover">
          <x-icon src="" :class="_.image" />
          <div :class="_.mask" />
        </div>
        <div :class="_.content">
          <x-icon :src="martData.store.storeLogo" :class="_.logo" />
          <div :class="_.info">
            <div :class="[_.name, _._ellipsis]">
              {{ martData.store.storeName }}
            </div>
            <div :class="_.desc">{{ total }}款商品供您选择</div>
          </div>
          <div
            v-if="
              martData.store.storeQualification &&
              martData.store.storeQualification.length
            "
            v-track="{
              name: '商家资质',
              id: 'cl56i6bds0002srqe8ykg1h7c',
            }"
            :class="_.cert"
            @click="handleCertClick"
          >
            <img src="./images/商家资质.png" :class="_.icon" />
            商家资质
          </div>
        </div>
      </div>

      <div :class="_.bd">
        <div v-if="martData.store.storeNotice" :class="_.notice">
          <div :class="_.label">
            <img src="./images/通知.png" :class="_.icon" />
          </div>
          <van-notice-bar :class="_.value" scrollable>
            {{ martData.store.storeNotice }}
          </van-notice-bar>
        </div>

        <div v-if="martData.fullCoupons.length" :class="_.coupon">
          <div :class="_.title">先领券再购买</div>
          <x-grid :col-count="2" :gap="11" :class="_.list">
            <div
              v-for="(item, index) in martData.fullCoupons"
              :key="item.activityId"
              :class="_.item"
            >
              <div :class="_.content">
                <div :class="_.price">
                  <div :class="_.unit">¥</div>
                  <div :class="_.value">{{ item.discountAmt }}</div>
                </div>
                <div :class="_.desc">{{ item.describe }}</div>
              </div>
              <div
                v-track="{
                  name: '立即领取',
                  id: '7ecdd13c-8b2f-4824-825b-a89c377c7ef1',
                  resource: {
                    id: item.activityId,
                    name: item.describe,
                    index: index,
                  },
                  resourcePosition: {
                    id: '8aaa8549801e16a701806f2bc80e0b98',
                    name: '先领券再购买',
                  },
                }"
                :class="_.button"
                @click="handleCouponClick(item.activityId)"
              >
                <div>立即</div>
                <div>领取</div>
              </div>
              <img
                v-if="item.receiveStatus === 1"
                src="./images/券-已领.png"
                :class="_.badge"
              />
            </div>
          </x-grid>
        </div>

        <div v-if="martData.store.storeActivityList.length" :class="_.banner">
          <van-swipe
            :autoplay="3000"
            :class="_.swiper"
            @change="index => (bannerIndex = index)"
          >
            <van-swipe-item
              v-for="(item, index) in martData.store.storeActivityList"
              :key="item.id"
              v-track="{
                name: '轮播图',
                id: 'd229de17-9db9-47e1-82f8-2de9d151c151',
                resource: {
                  id: item.id,
                  name: item.resourceName,
                  index: index,
                },
                resourcePosition: {
                  id: '8aaa8549801e16a701806f2cb34c0b9a',
                  name: '轮播图',
                },
              }"
              :class="_.item"
              @click.stop="handleBannerClick(item.resourceUrl)"
            >
              <van-image :src="item.imgUrl" fit="cover" :class="_.cover" />
            </van-swipe-item>
            <template
              v-if="martData.store.storeActivityList.length > 1"
              #indicator
            >
              <div :class="_.indicator">
                <div
                  v-for="i in martData.store.storeActivityList.length"
                  :key="i"
                  :class="[_.dot, bannerIndex === i - 1 && _.current]"
                />
              </div>
            </template>
          </van-swipe>
        </div>
      </div>
    </template>
  </SearchIndex>
</template>

<script>
  import SearchIndex from '../search/index'
  import Vue from 'vue'
  import {
    apiCommodityCommodityStoreDetail,
    apiMarketingCouponReceiveOpen,
    apiPageConfigDecorateHasTemplate,
  } from '@/api'
  import { dcb } from '@dcb/jssdk'
  import { mapQuery, prepareData, submit, Track } from '@/utils'
  import { navigateTo, redirectTo } from '@/router'

  export default Vue.extend({
    components: {
      SearchIndex,
    },

    mixins: [
      mapQuery({
        id: 'id',
      }),
      Track.provideMark(() => ({
        page: '店铺首页',
      })),
    ],

    data: () => ({
      loading: true,
      martData: {},
      bannerIndex: 0,
    }),

    computed: {
      searchPageProps() {
        return {
          title: this.martData.store?.storeName,
          loading: this.loading,
          classical: true,
        }
      },
    },

    mounted() {
      this.prepareData()
    },

    methods: {
      // 准备数据
      async prepareData() {
        // 如果有装修，跳装修页面
        const { hasDecorate } = await apiPageConfigDecorateHasTemplate({
          type: 'store',
          id: this.id,
        })
        if (hasDecorate) {
          redirectTo('DiyMartIndex', {
            id: this.id,
          })
          return
        }

        const { martData } = await prepareData({
          martData: apiCommodityCommodityStoreDetail({
            storeId: this.id,
          }),
        })
        this.martData = martData
        this.loading = false
      },

      // 点击商家资质
      handleCertClick() {
        navigateTo('MartCert', {
          id: this.id,
        })
      },

      // 点击优惠券
      handleCouponClick(couponId) {
        submit(async $ => {
          $.start('领取中...')
          await apiMarketingCouponReceiveOpen(
            {
              couponActId: couponId,
            },
            {
              errorMessageMap: {
                '没领到哦，你的单张券已领取达到上限': [1001, 1007, 1008],
                '活动已结束，无法继续领取': [1003, 1004, 1005],
                '领取失败，当前不在领取时段内': [1009],
                '领取失败，不符合领券要求': [1012],
              },
            },
          )
          await this.prepareData()
          await $.success('领取成功')
        })
      },

      // 点击轮播项
      handleBannerClick(url) {
        dcb.navigateTo({ url })
      },
    },
  })
</script>

<style lang="scss" module>
  .hd {
    position: relative;

    .cover {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;

      .image {
        width: 100%;
        height: 100%;
      }

      .mask {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          360deg,
          rgba(0, 0, 0, 0.46) 0%,
          rgba(0, 0, 0, 0.88) 100%
        );
        z-index: 1;
      }
    }

    .content {
      position: relative;
      padding-top: var(--page-header-height);
      padding-left: 12px;
      padding-bottom: 24px;
      display: flex;
      align-items: center;
      z-index: 2;

      .logo {
        flex-shrink: 0;
        width: 49px;
        height: 49px;
        border-radius: 50%;
      }

      .info {
        flex-grow: 1;
        margin-left: 12px;
        margin-right: 12px;
        overflow: hidden;

        .name {
          font-size: 18px;
          font-weight: bold;
          color: #ffffff;
        }

        .desc {
          margin-top: 6px;
          font-size: 14px;
          color: #ffffff;
        }
      }

      .cert {
        margin: 0 12px;
        flex-shrink: 0;
        width: 92px;
        height: 28px;
        background: linear-gradient(270deg, #e0aa7a 0%, #ffecd4 100%);
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 13px;
        font-weight: var(--bold-value);
        color: #4b1f02;
        line-height: 18px;

        .icon {
          margin-right: 2px;
          width: 15px;
          height: 15px;
        }

        &:active {
          filter: contrast(0.9);
        }
      }
    }
  }

  .bd {
    overflow: hidden;
    background-color: #f5f5f5;

    .notice {
      display: flex;
      align-items: center;
      margin: 12px;
      background: #ffffff;
      border-radius: 8px;
      overflow: hidden;

      .label {
        flex-shrink: 0;
        width: 44px;
        height: 44px;
        background: #fffafa;
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          width: 24px;
          height: 24px;
        }
      }

      .value {
        flex-grow: 1;
        background-color: transparent;
        color: inherit;
        padding: 0;
        height: 20px;
        font-size: inherit;
        font-size: 14px;
        color: #999999;
      }
    }

    .coupon {
      margin: 12px;
      background: #ffffff;
      border-radius: 8px;
      padding: 12px;

      .title {
        font-size: 14px;
        font-weight: var(--bold-value);
        color: #333333;
        line-height: 20px;
      }

      .list {
        margin-top: 12px;

        .item {
          position: relative;
          width: 100%;
          height: 72px;
          display: flex;
          align-items: center;
          background-image: url('./images/券-背景.png');
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;

          .content {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .price {
              display: flex;
              align-items: baseline;

              .unit {
                font-size: 12px;
                font-weight: var(--bold-value);
                color: #ff111c;
                line-height: 17px;
              }

              .value {
                margin-left: 3px;
                font-size: 30px;
                font-weight: var(--bold-value);
                color: #ff111c;
                line-height: 30px;
              }
            }

            .desc {
              font-size: 12px;
              color: #ff111c;
              line-height: 17px;
            }
          }

          .button {
            flex-shrink: 0;
            width: 62px;
            font-size: 14px;
            font-weight: var(--bold-value);
            color: #ff111c;
            line-height: 20px;
            text-align: center;
          }

          .badge {
            position: absolute;
            right: 0;
            bottom: 0;
            width: 36px;
            height: 34px;
          }
        }
      }
    }

    .banner {
      margin: 12px 0;
      padding: 0 12px;
      width: 100%;
      height: 100px;
      box-sizing: border-box;

      .swiper,
      .item,
      .cover {
        width: 100%;
        height: 100%;
        border-radius: 8px;
        overflow: hidden;
      }

      .indicator {
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 6px;
        // NOTE: 不可用 left: 50%  translateX(-50%) 居中  否则在部分安卓和电脑上会变形   原因未知

        .dot {
          width: 4px;
          height: 4px;
          background: rgba(0, 0, 0, 0.49);
          border-radius: 100px;

          + .dot {
            margin-left: 3px;
          }

          &.current {
            background: #cc0000;
          }
        }
      }
    }
  }
</style>
